import { render, staticRenderFns } from "./FeColumn.vue?vue&type=template&id=8331bf22&scoped=true&"
import script from "./FeColumn.vue?vue&type=script&lang=js&"
export * from "./FeColumn.vue?vue&type=script&lang=js&"
import style0 from "./FeColumn.vue?vue&type=style&index=0&id=8331bf22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8331bf22",
  null
  
)

export default component.exports